@if (icon) {
  <div>
    <rt-icon size="large-x" [name]="icon"></rt-icon>
  </div>
}

@if (imageUrl) {
  <div
    [class.img-fixed-dimensions]="!!fixedImageDimensions"
    [ngStyle]="{
      width: fixedImageDimensions?.width ? fixedImageDimensions?.width : 'auto',
      height: fixedImageDimensions?.height ? fixedImageDimensions?.height : 'auto'
    }"
  >
    <img src="{{ imageUrl }}" />
  </div>
}

@if (title) {
  <div class="heading" [class.with-icon]="titleIcon">
    @if (titleIcon) {
      <rt-icon [name]="titleIcon" size="large"></rt-icon>
    }
    {{ title }}
  </div>
}

@if (desc) {
  <div class="subheading" [innerHTML]="desc | rtPreventOrphans"></div>
}

<div class="content">
  <ng-content></ng-content>
</div>
